import { Navbar } from './Navbar'
import { SEO } from './SEO'
import { content } from '@/lib/content'
import { config } from '@/lib/constants'
import { Separator } from '@/components/ui/separator'

export function PageLayout({ children, title, description }) {
  return (
    <div className="min-h-screen bg-background">
      <SEO title={title} description={description} />
      <Navbar />
      <main className="pt-20">
        {children}
      </main>
      <footer className="bg-card border-t border-border py-12 mt-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-xl font-bold text-foreground mb-4">
                {content.footer.sections.about.heading}
              </h3>
              <p className="text-muted-foreground">
                {content.footer.sections.about.description}
              </p>
            </div>
            <div>
              <h3 className="text-xl font-bold text-foreground mb-4">
                {content.footer.sections.contact.heading}
              </h3>
              <div className="space-y-1 text-muted-foreground">
                <p>{config.managerName}</p>
                <p>{config.phoneNumber}</p>
                <p>{config.emailServerToEmail}</p>
              </div>
            </div>
            <div>
              <h3 className="text-xl font-bold text-foreground mb-4">
                {content.footer.sections.social.heading}
              </h3>
              <a
                href={config.facebookLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:text-primary/80 transition-colors"
              >
                {content.footer.sections.social.facebook}
              </a>
            </div>
          </div>
          <Separator className="my-8" />
          <div className="text-center text-muted-foreground">
            <p>&copy; {new Date().getFullYear()} {content.footer.copyright}</p>
          </div>
        </div>
      </footer>
    </div>
  )
}
